import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setLeftWorkAreaState } from '../../../redux/actions/product2dActions';

export const useTextInsert = ()=>{
 
  const makFabric = useSelector((state:any) => state.makFabric)
  const dispatch = useDispatch();
  
  const handleAddText = useCallback((text) => {
    if (makFabric) {
      makFabric.addText(text)
      dispatch(setLeftWorkAreaState("EDIT_TEXT"))
    }
  },[makFabric])

  return {
    handleAddText
  }

}